import React, { ReactNode } from 'react'
import { nowJob } from 'Content/Shared/Helpers/Constants'

export const WorkExperienceList: Array<WorkExperienceType> = [
  {
    title: <>Freelance front-end (Websites & iOS apps) and backend developer</>,
    company: 'Independent Contractor',
    location: 'Freelance',
    date: 'August 2020 - Present',
    description:
      'Completed over 7 production-ready apps and worked with clients from all over the world on building incredible: Websites, Backend APIs and Native (iOS) and Hybrid mobile apps',
  },
  {
    title: nowJob.title,
    company: nowJob.place,
    location: 'UK, London / Remote',
    date: 'June 2020 - Present',
    description:
      'Responsible for team coordination and integration of machine learning pipelines in both Frontend app (iOS in SwiftUI/UIKit) and Backend app (Node JS)',
  },
]

export interface WorkExperienceType {
  title: string | ReactNode
  company: string
  location: string
  date: string
  description: string
}
